export default __webpack_public_path__ + "static/media/animas_cable.ac27f0fe.png";